import { motion } from "framer-motion";
import { fadeUp } from "@/lib/motion";

// Envuelve contenido para revelarlo suavemente al entrar en viewport
export const Reveal = ({ children, className = "", variants = fadeUp, delay = 0, amount = 0.25, as = "div" }) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      variants={variants}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount }}
      transition={{ delay }}
    >
      {children}
    </MotionTag>
  );
};

export default Reveal;
